import { createContext as e } from "react";
const a = e({
  colorVariant: "primary",
  styleVariant: "tab",
  disabled: !1,
  tabs: [],
  activeTab: void 0,
  step: void 0,
  // eslint-disable-next-line no-console
  setActiveTab: () => {
    console.warn("TabContext::setActiveTab called before it was initialized");
  },
  // eslint-disable-next-line no-console
  registerTab: () => {
    console.warn("TabContext::registerTab called before it was initialized");
  },
  // eslint-disable-next-line no-console
  unregisterTab: () => {
    console.warn("TabContext::unregisterTab called before it was initialized");
  },
  // eslint-disable-next-line no-console
  setStep: () => {
    console.warn("TabContext::setStep called before it was initialized");
  }
});
export {
  a as default
};
